import React, { useState, MouseEvent, useEffect, useRef, ReactNode } from "react";
import ConfirmModal from "../ConfirmModal";
import { ConfirmActionPubSub, ConfirmActionPubSubPayload } from "@utils/pubsubs/PubSub";

export type ActionConfirmationProps = {
  onConfirm?: (e: MouseEvent<HTMLButtonElement>) => void;
  title: string;
  confirmBtnText?: string;
  primaryBtnColor?: string;
  secondaryBtn?: string;
  secondaryBtnColor?: string;
};

const ActionConfirmation: React.FC<ActionConfirmationProps> = ({
  title = "",
  confirmBtnText,
  primaryBtnColor,
  secondaryBtn,
  secondaryBtnColor
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [confirmMessage, setConfirmMessage] = useState<string | ReactNode>("");
  const onConfirmRef = useRef<() => void | null>(null!);
  const onCancelRef = useRef<() => void | null>(null!);

  useEffect(() => {

    const unsubscribe = ConfirmActionPubSub.subscribe(openConfirmation);
    return () => {
      unsubscribe();
    };
  }, [])

  const openConfirmation = (payload: ConfirmActionPubSubPayload) => {
    const { openOffCanvas, onConfirmCalback, onCancelCalback, confirmText } = payload;
    setConfirmMessage(confirmText)
    onConfirmRef.current = typeof onConfirmCalback === 'function' ? onConfirmCalback : () => { };
    onCancelRef.current = typeof onCancelCalback === 'function' ? onCancelCalback : () => { };
    setIsOpen(openOffCanvas);
  }

  const triggerConfirm = (e: MouseEvent<HTMLButtonElement>) => {
    onConfirmRef.current?.();
    setIsOpen(false)
  };

  const triggerOnCancel = (e: MouseEvent<HTMLButtonElement>) => {
    onCancelRef.current?.();
    setIsOpen(false)
  };

  const toggleModal = () => {
    setIsOpen((prev) => !prev);
    onCancelRef.current?.();
  };

  return (
    <>
      <ConfirmModal
        toggle={toggleModal}
        isOpen={isOpen}
        title={title}
        onConfirm={triggerConfirm}
        onCancel={triggerOnCancel}
        primaryBtn={confirmBtnText}
        primaryBtnColor={primaryBtnColor}
        secondaryBtn={secondaryBtn}
        secondaryBtnColor={secondaryBtnColor}
      >
        {confirmMessage}
      </ConfirmModal>
    </>
  );
};

export default ActionConfirmation;
